import { Skeleton } from 'antd';
import { Row } from 'farmhub-ui-core';

import { Wrapper } from './styles';

const PartnerNoteSkeleton = () => (
  <Wrapper>
    <Row justifyContent="space-between">
      <Row alignItems="center" styles={{ gap: 12 }}>
        <Skeleton.Input
          size="small"
          style={{ width: 28, height: 28, borderRadius: '6px' }}
        />

        <Skeleton.Input size="small" style={{ width: 250 }} />
      </Row>
      <Row styles={{ gap: 6 }} width="fit-content">
        <Skeleton.Input
          size="small"
          style={{ width: 28, height: 28, borderRadius: '50%' }}
        />
        <Skeleton.Input
          size="small"
          style={{ width: 28, height: 28, borderRadius: '50%' }}
        />
        <Skeleton.Input
          size="small"
          style={{ width: 28, height: 28, borderRadius: '50%' }}
        />
      </Row>
    </Row>
  </Wrapper>
);

export default PartnerNoteSkeleton;
